import React, { FC, Fragment } from 'react'
import styled from 'styled-components'

import { Stack } from 'components/Layout'
import Text from 'components/Text/Text'
import Button from 'components/Button/Button'

import type { EmptyStateWithIllustrationProps } from './EmptyState.types'
import Illustration from './Illustration'

const Wrapper = styled(Stack)`
  max-width: 320px;

  text-align: center;
`

const EmptyStateWithIllustration: FC<EmptyStateWithIllustrationProps> = ({
  variant = 'page',
  illustration,
  title,
  description,
  action,
  children,
  ...props
}: EmptyStateWithIllustrationProps) => {
  const isPageVariant = variant === 'page'

  return (
    <Wrapper {...props} align="center" justify="center" space="m">
      {children || (
        <Fragment>
          {illustration && (
            <Illustration illustration={illustration} scale={isPageVariant ? 'large' : 'default'} />
          )}
          {(title || description) && (
            <Stack space="xs">
              {title && (
                <Text
                  variant={isPageVariant ? 'heading-sm-bold' : 'body-bold'}
                  color={isPageVariant ? 'color-neutral-darkest' : 'color-neutral-darker'}
                >
                  {title}
                </Text>
              )}
              {description && (
                <Text
                  data-testid="empty-state-description"
                  variant={isPageVariant ? 'body' : 'caption'}
                  color="color-neutral-darkest"
                >
                  {description}
                </Text>
              )}
            </Stack>
          )}
          {action && (
            <Button
              className="empty-state-action"
              variant="primary"
              scale={isPageVariant ? 'default' : 'small'}
              {...action}
            >
              {action.label}
            </Button>
          )}
        </Fragment>
      )}
    </Wrapper>
  )
}

export default EmptyStateWithIllustration
